export const SMALLEST_COMPANY_SIZE = "1-19";
export const companySizeList = [SMALLEST_COMPANY_SIZE, "20-49", "50-99", "100-250", "251-1500", "1500+"];
